import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import shp from 'shpjs';
import franceRaiwayLayer from '../../../assets/data/GUARDEN_FR_railwaynetwork.zip';

export interface RailwayMapControlOptions extends L.ControlOptions {
  railwayLayerStyle?: L.PathOptions;
}

export class RailwayMapControl extends L.Control {
  private map: L.Map | null = null;
  private currentLayerGroup: L.LayerGroup | null = null;
  private layerData: Record<string, GeoJSON.GeoJSON> = {};

  private LAYER_GROUPS: Record<string, string[]> = {
    Current: ['GUARDEN_FR_railwaynetwork/FR_current_railway', 'GUARDEN_FR_railwaynetwork/FR_railway_stations'],
    Conservation: ['GUARDEN_FR_railwaynetwork/FR_railway_scenario_conservation'],
    Development: ['GUARDEN_FR_railwaynetwork/FR_railway_scenario_development'],
    Utopian: ['GUARDEN_FR_railwaynetwork/FR_railway_scenario_utopian'],
  };

  onAdd(map: L.Map): HTMLElement {
    this.map = map;

    const container = L.DomUtil.create('div', 'leaflet-control-railway');
    container.style.backgroundColor = 'white';
    container.style.padding = '12px';
    container.style.borderRadius = '8px';
    container.style.boxShadow = '0 2px 6px rgba(0,0,0,0.2)';
    container.style.fontFamily = 'sans-serif';
    container.style.fontSize = '14px';

    const title = L.DomUtil.create('label', '', container);
    title.innerHTML = 'Select Railway Layer:';
    title.setAttribute('for', 'railway-layer-select');
    title.style.display = 'block';
    title.style.marginBottom = '6px';
    title.style.fontWeight = 'bold';

    const select = L.DomUtil.create('select', '', container);
    select.id = 'railway-layer-select';
    select.style.width = '100%';
    select.style.padding = '6px';
    select.style.borderRadius = '4px';
    select.style.border = '1px solid #ccc';

    this.loadRailwayLayers(select);

    return container;
  }

  private async loadRailwayLayers(select: HTMLSelectElement) {
    if (!this.map) return;

    const geojsonLayers = await shp(franceRaiwayLayer);
    const geojsonArray: any[] = Array.isArray(geojsonLayers) ? geojsonLayers : [geojsonLayers];

    geojsonArray.forEach((layer: any) => {
      this.layerData[layer.fileName] = layer;
    });

    this.createDropdownOption(select, 'Select railway layer', '', true);
    for (const label of Object.keys(this.LAYER_GROUPS)) {
      this.createDropdownOption(select, label, label);
    }

    select.addEventListener('change', (e) => {
      const target = e.target as HTMLSelectElement;
      this.updateLayers(target.value);
    });
  }

  private createDropdownOption(select: HTMLSelectElement, label: string, value: string, selected = false) {
    const option = document.createElement('option');
    option.text = label;
    option.value = value;
    option.selected = selected;
    select.appendChild(option);
  }

  private updateLayers(label: string) {
    if (!this.map) return;

    if (this.currentLayerGroup) {
      this.map.removeLayer(this.currentLayerGroup);
      this.currentLayerGroup = null;
    }

    if (!label || !(label in this.LAYER_GROUPS)) return;

    const fileKeys = this.LAYER_GROUPS[label];
    const layers: L.Layer[] = [];

    for (const key of fileKeys) {
      const geojson = this.layerData[key];
      if (!geojson) continue;

      const layer = L.geoJSON(geojson, {
        style: {
          color: 'orange',
          weight: 3,
          opacity: 0.8
        },
        onEachFeature: (feature, layer) => {
          if (feature.properties) {
            const content = Object.entries(feature.properties)
              .filter(([, value]) => value !== null && value !== undefined && value !== '')
              .map(([key, value]) => `<strong>${key}:</strong> ${value}`)
              .join('<br>');
            if (content) layer.bindPopup(content);
          }
        },
      });

      layers.push(layer);
    }

    this.currentLayerGroup = L.layerGroup(layers);
    this.currentLayerGroup.addTo(this.map);
  }
}